<template>
    <div>
        <top :type="false"></top>
        <div class="box">
            <div class="title">
                选择收获地址
            </div>
            <div class="address flex ali-cen flex-wrap">
                <div
                    :class="
                        item.id == addressId
                            ? 'address-item address-item-true'
                            : 'address-item'
                    "
                    v-for="(item, index) in addressList"
                    :key="index"
                    @click="click(item.id)"
                >
                    <div>收货人：{{ item.consignee }}</div>
                    <div>电话：{{ item.phone }}</div>
                    <div class="text-ellipsis">
                        地址：{{
                            item.province_name +
                                item.city_name +
                                item.area_name +
                                item.address
                        }}
                    </div>
                </div>
                <div class="address-add" @click="show = true">
                    <i class="ficon-add-o iconfont"></i>
                    新增收货地址
                </div>
            </div>
        </div>
        <div class="box">
            <div class="title">
                确认订单信息
            </div>
            <div class="order">
                <el-table :data="tableData" style="width: 100%">
                    <el-table-column label="商品名称">
                        <template slot-scope="scope">
                            <div class="flex ali-cen">
                                <img
                                    :src="scope.row.title.img"
                                    alt=""
                                    style="width: 97px;height: 89px;"
                                />
                                <span style="margin-left: 10px">{{
                                    scope.row.title.name
                                }}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="属性" width="180">
                        <template slot-scope="scope">
                            {{ scope.row.type }}
                        </template>
                    </el-table-column>
                    <el-table-column label="单价">
                        <template slot-scope="scope">
                            {{ scope.row.money }}
                        </template>
                    </el-table-column>
                    <el-table-column label="数量">
                        <template slot-scope="scope">
                            {{ scope.row.num }}
                        </template>
                    </el-table-column>
                    <el-table-column label="小记">
                        <template slot-scope="scope">
                            <span style="color: #FF6701;font-size: 20px;">
                                ￥{{ scope.row.money }}
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="con flex jus-between">
                <!-- <el-checkbox
                    :disabled="disabled"
                    v-model="checked"
                    @change="faPioabtn"
                    dialogVisible
                    >个人发票</el-checkbox
                > -->
                <!-- <el-checkbox
                    :disabled="disabled1"
                    v-model="checkedFirm"
                    @change="faPioabtns"
                    dialogVisibleFirm
                    >企业发票</el-checkbox
                > -->
                <el-checkbox
                    v-model="checkedFirm"
                    @change="kai_ju"
                    dialogTableVisible
                    >开具发票</el-checkbox
                >
                <div class="text flex" style="width: 450px;">
                    <div style="width: 80px;">买家留言</div>
                    <el-input
                        type="textarea"
                        placeholder="请输入内容"
                        v-model="remark"
                        maxlength="100"
                        show-word-limit
                    >
                    </el-input>
                </div>
                <div class="flex ali-cen">
                    <div>运送方式：</div>
                    <el-select
                        v-model="value1"
                        @change="handleExpressBtn"
                        placeholder="请选择快递公司"
                    >
                        <el-option
                            v-for="item in express_btn"
                            :key="item.value"
                            :label="item.title"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="elect" style="margin:40px 0">
                请选择优惠卷:
                <el-select
                    v-model="value"
                    clearable
                    @clear="counRemove"
                    @change="handleCoun"
                    placeholder="不使用优惠卷"
                >
                    <el-option
                        v-for="item in options"
                        :key="item.user_coupons_id"
                        :label="'满' + item.enough + '减' + item.amount"
                        :value="item.user_coupons_id"
                    >
                    </el-option>
                </el-select>
            </div>
            <div class="infoss">
                <div>
                    寄送至:{{
                        addressInfo.province_name +
                            addressInfo.city_name +
                            addressInfo.area_name +
                            addressInfo.address
                    }}
                </div>
                <div>收货人：{{ addressInfo.consignee }}</div>
                <div class="flex jus-end">
                    合计（含运费）：<span>¥{{ total_fee }}</span>
                </div>
            </div>
            <div
                class="confirm"
                style="width: 214px;background: #FF6701;margin:50px auto;"
                @click="confrim"
            >
                提交订单
            </div>
        </div>
        <bottom></bottom>
        <add :show="show" @showNull="showNull"></add>

        <!-- 企业发票 -->
        <el-dialog
            title="开具发票"
            :visible.sync="dialogVisibleFirm"
            :before-close="handleCloses"
        >
            <el-form :model="firm">
                <el-form-item label="发票类型">
                    <el-select
                        v-model="firm.invoice_type"
                        placeholder="请选择发票类型"
                    >
                        <el-option
                            label="增值税电子专用发票"
                            value="ord"
                        ></el-option>
                        <el-option
                            label="增值税电子普通发票"
                            value="pro"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="抬头类型">
                    <el-radio label="enterprise" v-model="firm.type"
                        >企业或事业单位</el-radio
                    >
                </el-form-item>
                <el-form-item label="发票抬头">
                    <el-input v-model="firm.title"></el-input>
                </el-form-item>
                <el-form-item label="税号">
                    <el-input
                        style="margin-left:28px"
                        v-model="firm.tax_number"
                    ></el-input>
                </el-form-item>
                <el-form-item label="开户银行">
                    <el-input v-model="firm.bank_name"></el-input>
                    <span>选填</span>
                </el-form-item>
                <el-form-item label="银行账号">
                    <el-input v-model="firm.card_no"></el-input>
                    <span>选填</span>
                </el-form-item>
                <el-form-item label="企业地址">
                    <el-input v-model="firm.address"></el-input>
                    <span>选填</span>
                </el-form-item>
                <el-form-item label="企业电话">
                    <el-input v-model="firm.tel"></el-input>
                    <span>选填</span>
                </el-form-item>

                <el-form-item label="发票内容">
                    <el-checkbox v-model="firm.need_detail">明细</el-checkbox>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="invoiceAddListFirm"
                        >提交申请</el-button
                    >
                </el-form-item>
            </el-form>
        </el-dialog>
        <!-- 开具发票 -->
        <el-dialog title="开具发票" :visible.sync="dialogTableVisible">
            <div class="address flex ali-cen flex-wrap">
                <div
                    :class="
                        item.id == invoceId
                            ? 'address-items address-item-true'
                            : 'address-items'
                    "
                    v-for="(item, index) in invoceLists"
                    :key="index"
                    @click="invoceClick(item.id)"
                >
                    <div style="color:#333333;font-size:16px;font-weight:600">企业抬头</div>
                    <div>{{ item.title }}</div>
                    <div class="invoice_icon">
                        <span @click="editInvoce(item)">
                            <img src="../../images/编组.png" alt="" />
                            编辑
                        </span>
                        <span @click="delInvoce(item.id)">
                            <img src="../../images/垃圾桶.png" alt="" />
                            删除
                        </span>
                    </div>
                </div>
                <div class="address-add" style="line-height:161px" @click="dialogVisibleFirm = true">
                    <img src="../../images/添加.png" alt="">
                    <!-- <i class="ficon-add-o iconfont"></i> -->
                </div>
            </div>
        </el-dialog>
        <!-- 编辑发票 -->
        <el-dialog
            title="编辑发票"
            :visible.sync="dialogVisibleFirmEdit"
            :before-close="handleCloses"
        >
            <el-form :model="editForm">
                <el-form-item label="发票类型">
                    <el-select
                        v-model="editForm.invoice_type"
                        placeholder="请选择发票类型"
                    >
                        <el-option
                            label="增值税电子专用发票"
                            value="ord"
                        ></el-option>
                        <el-option
                            label="增值税电子普通发票"
                            value="pro"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="抬头类型">
                    <el-radio label="enterprise" v-model="editForm.type"
                        >企业或事业单位</el-radio
                    >
                </el-form-item>
                <el-form-item label="发票抬头">
                    <el-input v-model="editForm.title"></el-input>
                </el-form-item>
                <el-form-item label="税号">
                    <el-input
                        style="margin-left:28px"
                        v-model="editForm.tax_number"
                    ></el-input>
                </el-form-item>
                <el-form-item label="开户银行">
                    <el-input v-model="editForm.bank_name"></el-input>
                    <span>选填</span>
                </el-form-item>
                <el-form-item label="银行账号">
                    <el-input v-model="editForm.card_no"></el-input>
                    <span>选填</span>
                </el-form-item>
                <el-form-item label="企业地址">
                    <el-input v-model="editForm.address"></el-input>
                    <span>选填</span>
                </el-form-item>
                <el-form-item label="企业电话">
                    <el-input v-model="editForm.tel"></el-input>
                    <span>选填</span>
                </el-form-item>

                <el-form-item label="发票内容">
                    <el-checkbox v-model="editForm.need_detail"
                        >明细</el-checkbox
                    >
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="invoiceAddListFirmEdit"
                        >确认编辑</el-button
                    >
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import top from "../../components/top.vue";
import bottom from "../../components/bottom.vue";
import add from "../../components/address.vue";
import {
    address,
    pre,
    createOrder,
    invoiceAdd,
    orderCoupons,
    invoiceList,
    invoiceDel,
    invoiceEdit
} from "@/api/index.js";
// var token = JSON.parse(sessionStorage.getItem('userInfo')).token
// var header = {'Content-Type':'application/json','token':token,'platform':'H5'}
if (window.localStorage.getItem("userInfo")) {
    var token = JSON.parse(window.localStorage.getItem("userInfo")).token;
    var header = {
        "Content-Type": "application/json",
        token: token,
        platform: "H5"
    };
}
export default {
    data() {
        return {
            addressList: [],
            addressId: "",
            invoceId: "",
            goodsInfos: [],
            goodsInfo: [],
            addressInfo: {},
            goodsDetail: {},
            tableData: [],
            show: false,
            remark: "",
            from: "",
            checked: "",
            checkedFirm: "",

            dialogVisibleFirm: false,
            dialogVisibleFirmEdit: false,
            invrceForm: {
                invoice_type: "",
                title: "",
                need_detail: "",
                type: "personal"
            },
            firm: {
                invoice_type: "",
                title: "",
                need_detail: "",
                type: "enterprise",
                tax_number: "",
                bank_name: "",
                card_no: "",
                address: "",
                tel: ""
            },
            editForm: {
                invoice_type: "",
                title: "",
                need_detail: "",
                type: "enterprise",
                tax_number: "",
                bank_name: "",
                card_no: "",
                address: "",
                tel: ""
            },
            disabled: false,
            disabled1: false,
            dialogTableVisible: false,
            options: [],
            value: "",
            pr: null,
            coupon: null,
            express_btn: [],
            value1: "中通快递",
            expressVal: '',
            total_fee: null,
            invoceLists: [],
            coupinsId:''
        };
    },
    beforeCreate() {},
    created() {
        this.address();
        this.goods();

        this.getOrderCoupons();
    },
    methods: {
        address() {
            address("", header).then(res => {
                if (res.code == 1) {
                    this.addressList = res.data;
                    this.addressId = res.data[0].id;
                    this.addressInfo = res.data[0];
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        showNull() {
            console.log("2222");
            this.show = false;
            this.address();
        },
        click(id) {
            console.log(id, "ss");
            this.addressId = id;
            this.addressList.forEach(i => {
                if (id == i.id) {
                    this.addressInfo = i;
                }
            });
        },
        invoceClick(id) {
            console.log(id);
            this.invoceId = id;
        },
        editInvoce(item) {
            console.log(item);
            this.editForm = item;
            this.dialogVisibleFirmEdit = true;
        },
        goods() {
            this.getGoodInfo();

            pre(
                {
                    goods_list: this.goodsInfo[0],
                    from: this.from,
                    address_id: 0,
                    order_type: "goods",
                    buy_type: "alone",
                    coupons_id: 0,
                    groupon_id: 0,
                    express: 'pt'
                },
                header
            ).then(res => {
                console.log('resssssssss',res);

                if (res.code == 1) {
                    this.express_btn = res.data.express_btn;
                    this.expressVal= res.data.express_btn[0].value;
                    console.log('expressVal==',this.express)
                    this.goodsDetail = res.data;
                    this.coupon = res.data.total_amount;
                    this.total_fee = res.data.total_fee;
                    let arr = [];
                    res.data.new_goods_list.forEach(i => {
                        let obj = {
                            title: {
                                img: i.detail.image,
                                name: i.detail.title
                            },
                            type: i.detail.current_sku_price.goods_sku_text,
                            pirce: i.detail.price,
                            num: i.goods_num,
                            money: Number(i.goods_num) * Number(i.goods_price)
                        };
                        arr.push(obj);
                    });
                    this.tableData = arr;
                    console.log(this.tableData);
                } else {
                    console.log(res.msg);
                    this.$message.error(res.msg);
                }
            });
        },
        confrim() {
            let obj = {
                address_id: this.addressId,
                buy_type: "alone",
                coupons_id: this.coupinsId,
                from: "goods",
                goods_list: this.goodsInfos[0],
                groupon_id: "0",
                order_type: "goods",
                remark: this.remark,
                express: this.expressVal,
                invoice_id:this.invoceId
            };
            console.log(obj);
            createOrder(obj, header).then(res => {
                if (res.code == 1) {
                    this.$router.push({
                        name: "pay",
                        query: { id: res.data.id, orderSn: res.data.order_sn }
                    });
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        getGoodInfo() {
            let userI = JSON.parse(this.$route.query.goods);
            this.goodsInfos.push(userI);
            //
            let userIs = JSON.parse(this.$route.query.goods);
            delete userIs[0].dispatch_type;
            this.goodsInfo.push(userIs);

            console.log(this.goodsInfo[0]);
            this.from = this.$route.query.from;
            console.log(this.from);
        },
        handleClose(done) {
         console.log('sss');

        },
        handleCloses() {
            console.log('sss');
            this.dialogVisibleFirm = false;

            this.dialogVisibleFirmEdit = false;
        },


        //开具发票
        kai_ju() {
            if(this.checkedFirm){
               invoiceList({}, header).then(res => {
                console.log(res);
                if (res.code !== 1) {
                    return;
                }
                this.invoceLists = res.data;
                this.invoceId = res.data[0].id;
            });
            this.dialogTableVisible = true;
            }
            this.invoceId = ''


        },
        //删除发票
        delInvoce(id) {
            console.log(id);
            invoiceDel({ ids: id }, header).then(res => {
                this.kai_ju();
                console.log(res);
            });
        },

        // 提交个人开票
        // invoiceAddList() {
        //     let obj = {
        //         invoice_type: this.invrceForm.invoice_type,
        //         title: this.invrceForm.title,
        //         need_detail: Number(this.invrceForm.need_detail),
        //         type: this.invrceForm.type
        //     };
        //     console.log(obj);
        //     invoiceAdd(obj, header).then(res => {
        //         if (res.code !== 1) {
        //             return this.$message.error(res.msg);
        //         }
        //         this.$message.success(res.msg);
        //         this.dialogVisible = false;
        //         this.disabled1 = true;
        //     });
        // },
        //提交企业开票
        invoiceAddListFirm() {
            let objs = {
                invoice_type: this.firm.invoice_type,
                title: this.firm.title,
                need_detail: Number(this.firm.need_detail),
                type: this.firm.type,
                tax_number: this.firm.tax_number,
                bank_name: this.firm.bank_name,
                card_no: this.firm.card_no,
                address: this.firm.address,
                tel: this.firm.tel
            };
            invoiceAdd(objs, header).then(res => {
                if (res.code !== 1) {
                    return this.$message.error(res.msg);
                }
                this.$message.success(res.msg);

                this.dialogVisibleFirm = false;
                this.disabled = false;
                this.kai_ju();
            });
        },
        //提交编辑企业开票
        invoiceAddListFirmEdit() {
            let editObj = {
                id: this.invoceId,
                invoice_type: this.editForm.invoice_type,
                title: this.editForm.title,
                need_detail: Number(this.editForm.need_detail),
                type: this.editForm.type,
                tax_number: this.editForm.tax_number,
                bank_name: this.editForm.bank_name,
                card_no: this.editForm.card_no,
                address: this.editForm.address,
                tel: this.editForm.tel
            };
            console.log(editObj);
            invoiceEdit(editObj, header).then(res => {
                if (res.code !== 1) {
                    return this.$message.error(res.msg);
                }
                this.$message.success(res.msg);
                this.dialogVisibleFirmEdit = false;
                this.kai_ju();
            });
        },
        //获取优惠卷
        getOrderCoupons() {
            console.log(this.goodsInfos[0]);
            orderCoupons({ goods_list: this.goodsInfos[0] }, header).then(
                res => {
                    console.log(res);
                    if (res.code !== 1) {
                        return;
                    }
                    this.options = res.data;
                    console.log(this.options);
                }
            );
        },
        //优惠卷
        handleCoun(index, value) {
            console.log(index);
            this.coupinsId = index
             pre(
                {
                    goods_list: this.goodsInfo[0],
                    from: this.from,
                    address_id: 0,
                    order_type: "goods",
                    buy_type: "alone",
                    coupons_id: index,
                    groupon_id: 0,
                    express:this.expressVal

                },
                header
            ).then(res => {
                console.log(res);
                if (res.code !== 1) {
                    return this.$message.error(res.msg);
                }
                this.total_fee = res.data.total_fee;
            });

        },
        counRemove(val) {

        },
        handleExpressBtn(val) {
            console.log(val);
            this.expressVal = val;
            pre(
                {
                    goods_list: this.goodsInfo[0],
                    from: this.from,
                    address_id: 0,
                    order_type: "goods",
                    buy_type: "alone",
                    coupons_id: this.coupinsId,
                    groupon_id: 0,
                    express: val
                },
                header
            ).then(res => {
                console.log(res);
                if (res.code !== 1) {
                    return this.$message.error(res.msg);
                }
                this.total_fee = res.data.total_fee;
            });
        }
    },
    components: {
        top,
        bottom,
        add
    }
};
</script>

<style lang="less" scoped>
.invoice_icon {
    display: flex;
    justify-content: space-between;
}
.address-items {
    margin-right: 20px;
    width: 268px;
    padding: 20px;
    border: 1px solid #999999;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 141px;
}
/deep/.el-dialog__body {
    // margin-left: 100px;
}
/deep/.el-form-item__content {
    color: #cecece !important;
}
.el-input {
    width: 200px;
}
.banner {
    width: 100%;
}
.confirm{
    cursor: pointer;
}
.box {
    width: 1200px;
    margin: 0 auto 30px;
    background: #ffffff;
    border-radius: 8px;
    border: 1px solid #0097fe;
    padding: 0px 30px;

    .title {
        font-size: 20px;
        color: #333;
        height: 50px;
        line-height: 50px;
    }
}

.address {
    > div {
        margin-bottom: 20px;
    }
    .address-item {
        margin-right: 20px;
        width: 268px;
        padding: 20px;
        border: 1px solid #999999;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 141px;
        &:nth-child(4n + 4) {
            margin-right: 0;
        }
    }

    .address-item-true {
        border: 1px solid #ff6701;
    }
    .address-add {
        width: 268px;
        height: 141px;
        text-align: center;
        line-height: 141px;
        border: 1px solid #999999;
    }
}
.con {
    margin: 30px 0;
    font-size: 14px;
    .btn {
        width: 106px;
        height: 38px;
        border-radius: 1px;
        border: 1px solid #f0f0f0;
        text-align: center;
        line-height: 38px;
        margin-right: 10px;
        color: #666666;
    }
}
.infoss {
    div {
        margin-bottom: 20px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/index/confirm.vue